import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  TableauViz,
  useTableauVizRef,
  useTableauAuthoringVizFirstInteractiveCallback,
} from '@tableau/embedding-api-react'
import { tableauParameterConstants } from '../../../../constants/tableau-constants'

function TableauDashboard({ tableauDashboardURL, tableauToken, clientCode }) {
  const vizRef = useTableauVizRef()
  const [vizLoaded, setVizLoaded] = useState(false)

  useEffect(() => {
    if (clientCode && vizLoaded) {
      vizRef.current.workbook.changeParameterValueAsync(
        tableauParameterConstants.ORGANIZATION_PARAMETER,
        clientCode,
      )
    }
  }, [clientCode, vizLoaded, vizRef])

  const handleFirstInteractive = useTableauAuthoringVizFirstInteractiveCallback(
    (event) => {
      const { target: viz } = event
      setVizLoaded(true)
      viz.workbook.changeParameterValueAsync(
        tableauParameterConstants.ORGANIZATION_PARAMETER,
        clientCode,
      )
    },
    [clientCode],
  )

  return (
    <TableauViz
      ref={vizRef}
      height='1200px'
      width='1300px'
      src={tableauDashboardURL}
      toolbar='hidden'
      hideTabs
      token={tableauToken}
      onFirstInteractive={handleFirstInteractive}
    />
  )
}

TableauDashboard.propTypes = {
  tableauDashboardURL: PropTypes.string,
  tableauToken: PropTypes.string,
  clientCode: PropTypes.string,
}

export default TableauDashboard
